import React, { useState, useEffect } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { getDefaultLang, langs } from "../../utils";
import { MobileFooter } from "./MobileFooter";
import Tooltip from "rc-tooltip";
const defaultLang = getDefaultLang();

const setCookieLang = (lang) => {
  const topLevelDomain = window.location.hostname
    .split(".")
    .slice(-2)
    .join(".");
  document.cookie = `_authing_lang=${lang}; path=/; domain=${topLevelDomain}`;
};

export const Footer = () => {
  let { i18n, t } = useTranslation();

  const [lang] = useState(defaultLang);
  //
  const change = (event) => {
    const _lang = event.target.value;
    i18n.changeLanguage(_lang);
    setCookieLang(_lang);
    window.location.reload();
  };
  const onOutLink = (path) => {
    window.location.href = path;
  };

  useEffect(() => {
    i18n.changeLanguage(lang);
    setCookieLang(lang);
  }, [lang, i18n]);

  const userManegeList = [
    {
      title: `${t("common.footer.footer-product-advance")}`,
      path: "/advantage",
    },
    {
      title: `${t("common.common.product-verify")}`,
      path: "/verify",
    },
    {
      title: `${t("common.common.product-comp")}`,
      path: "/learn/guard",
    },
    {
      title: `${t("common.common.product-sso")}`,
      path: "/learn/sso",
    },
    {
      title: `${t("common.common.product-mfa")}`,
      path: "/mfa",
    },
  ];

  const solutionList = [
    {
      title: t("common.footer.footer-solution-wechat"),
      path: "/solutions/wechat",
    },
    {
      title: t("common.nav.nav-solution-build-idaas"),
      path: "/solutions/build-idaas",
    },
    {
      title: t("common.nav.nav-solution-idaas"),
      path: "/solutions/idaas",
    },
    {
      title: t("common.nav.nav-solution-okta"),
      path: "/solutions/okta",
    },

    {
      title: t("common.footer.footer-solution-cognito"),
      path: "/solutions/cognito",
    },
  ];

  const developList = [
    {
      title: `${t("common.footer.footer-support-doc")}`,
      path: "//docs.authing.cn/",
    },
    {
      title: `${t("common.footer.footer-support-community")}`,
      path: "//forum.authing.cn/",
    },
    {
      title: `${t("common.footer.footer-support-Github")}`,
      path: "//github.com/authing",
    },
    {
      title: `${t("common.footer.footer-support-blog")}`,
      path: "//blog.authing.cn/blog/",
    },
    {
      title: `Authing Timeline`,
      path: "/changelog",
    },
    // {
    //   title: t("common.footer.footer-pay-news"),
    //   path: "/pay-news",
    // },
  ];
  const communityLink = [
    {
      imgUrl: "//files.authing.co/authing-website/github.svg",
      icon: "icon authing-icon authing-wechat-pc",
      path: "//github.com/Authing",
      type: "wechat",
    },
    {
      imgUrl: "//files.authing.co/authing-website/github.svg",
      icon: "icon authing-icon authing-github",
      path: "//github.com/Authing",
    },
    {
      imgUrl: "//files.authing.co/authing-website/gitter.svg",
      icon: "icon authing-icon authing-gitter",
      path: "//forum.authing.cn/",
    },
    {
      imgUrl: "//files.authing.co/authing-website/zhihu.svg",
      icon: "icon authing-icon authing-zhihu",
      path: "//www.zhihu.com/org/authing",
    },
  ];

  const menuList = [
    { name: t("common.footer.footer-product"), children: userManegeList },
    { name: t("common.footer.footer-solution"), children: solutionList },
    { name: t("common.footer.footer-support"), children: developList },
    {
      name: t("common.footer.footer-company"),
      children: [
        {
          title: t("common.footer.footer-company-phone"),
          path: null,
        },
        {
          title: t("common.footer.footer-company-email"),
          path: null,
        },
        {
          title: t("common.footer.mobile-total-company-address"),
          path: null,
        },
        {
          title: t("common.footer.mobile-branch-company-address"),
          path: null,
        },
        {
          title: t("common.footer.mobile-shanghai-company-address"),
          path: null,
        },
        {
          title: t("common.footer.mobile-wuhan-company-address"),
          path: null,
        },
      ],
    },
  ];

  const renderFooter = () => {
    return (
      <div className="authing-pc-footer-display">
        <div className="footer-warp">
          <div className="inner">
            <div className="footer">
              <div
                className="logo"
                onClick={() => {
                  onOutLink("/");
                }}
              >
                <img
                  src={
                    "//files.authing.co/authing-website/authing-logo-0830.png"
                  }
                  alt=""
                />
              </div>
              <div className="block">
                <div className="title">{t("common.footer.footer-product")}</div>
                {userManegeList.map((item, index) => {
                  return (
                    <a key={index} className="item" href={item.path}>
                      {item.title}
                    </a>
                  );
                })}
              </div>
              <div className="block">
                <div className="title">
                  {t("common.footer.footer-solution")}
                </div>
                {solutionList.map((item, index) => {
                  return (
                    <a
                      key={index}
                      className="item"
                      href={item.path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.title}
                    </a>
                  );
                })}
                <a
                  style={{ opacity: 0 }}
                  className="item"
                  href="https://authing.cn/sitemap.xml"
                >
                  {t("common.footer.footer-sitemap")}
                </a>
              </div>
              <div className="block">
                <div className="title">{t("common.footer.footer-support")}</div>
                {developList.map((item, index) => {
                  return (
                    <a
                      key={index}
                      className="item"
                      href={item.path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.title}
                    </a>
                  );
                })}
                {/* <a
                  style={{ opacity: 0 }}
                  className="item"
                  href="https://authing.cn/sitemap.xml"
                >
                  {t("common.footer.footer-sitemap")}
                </a> */}
              </div>
              <div className="block">
                <div className="title">{t("common.footer.footer-company")}</div>
                <a href="/joinus" className="item">
                  {t("common.footer.footer-company-joinus")}
                </a>
                <a href="/tool-package" className="item">
                  {t("common.tool-package.title")}
                </a>
                {/* <div className="item-default">15559944612</div>
                <div className="item-default">
                  {t("common.footer.footer-company-email")}
                </div> */}
                <div className="item-default">
                  <Tooltip
                    placement="right"
                    mouseLeaveDelay={0.001}
                    trigger={["hover"]}
                    overlay={t("common.footer.beijing-company-address")}
                  >
                    <a
                      className="companyAddress"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://map.baidu.com/search/%E5%8C%97%E8%BE%B0%E4%B8%96%E7%BA%AA%E4%B8%AD%E5%BF%83-b%E5%BA%A7/@12957096.065,4838990.38,19z?querytype=s&da_src=shareurl&wd=%E5%8C%97%E8%BE%B0%E4%B8%96%E7%BA%AA%E4%B8%AD%E5%BF%83-b%E5%BA%A7&c=131&src=0&pn=0&sug=0&l=12&b=(12913638.56,4802627.47;13004838.56,4848067.47)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2"
                    >
                      {t("common.footer.company-address-name")}
                    </a>
                  </Tooltip>
                  <br />
                  {/* <span className="companyAddress">
                    {t("common.footer.extendAdress")}
                  </span>
                  <br /> */}
                  <Tooltip
                    placement="right"
                    mouseLeaveDelay={0.001}
                    trigger={["hover"]}
                    overlay={t("common.footer.chengdu-company-address")}
                  >
                    <a
                      className="companyAddress"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://map.baidu.com/search/%E5%9B%9B%E5%B7%9D%E7%9C%81%E6%88%90%E9%83%BD%E5%B8%82%E9%AB%98%E6%96%B0%E5%8C%BA%E5%A4%A9%E5%BA%9C%E4%BA%94%E8%A1%97200%E5%8F%B7/@11584949.095,3551926.08,19z?querytype=s&da_src=shareurl&wd=%E5%9B%9B%E5%B7%9D%E7%9C%81%E6%88%90%E9%83%BD%E5%B8%82%E9%AB%98%E6%96%B0%E5%8C%BA%E5%A4%A9%E5%BA%9C%E4%BA%94%E8%A1%97200%E5%8F%B7&c=75&src=0&pn=0&sug=0&l=19&b=(11584592.845,3551748.58;11585305.345,3552103.58)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2"
                    >
                      {t("common.footer.branch-address-name")}
                    </a>
                  </Tooltip>
                  <br />
                  <Tooltip
                    placement="right"
                    mouseLeaveDelay={0.001}
                    trigger={["hover"]}
                    overlay={t("common.footer.shanghai-company-address")}
                  >
                    <a
                      className="companyAddress"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://map.baidu.com/search/%E4%B8%8A%E6%B5%B7%E5%B8%82%E6%9D%A8%E6%B5%A6%E5%8C%BA%E6%94%BF%E6%B0%91%E8%B7%AF%20300/@13526698.060111606,3650411.68,17.82z?querytype=s&da_src=shareurl&wd=%E4%B8%8A%E6%B5%B7%E5%B8%82%E6%9D%A8%E6%B5%A6%E5%8C%BA%E6%94%BF%E6%B0%91%E8%B7%AF%20300&c=289&src=0&pn=0&sug=0&l=19&b=(13526042.625,3650077;13526739.625,3650393)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2"
                    >
                      {t("common.footer.shanghai-address-name")}
                    </a>
                  </Tooltip>
                  <br />
                  <Tooltip
                    placement="right"
                    mouseLeaveDelay={0.001}
                    trigger={["hover"]}
                    overlay={t("common.footer.wuhan-company-address")}
                  >
                    <a
                      className="companyAddress"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://map.baidu.com/search/%E6%AD%A6%E6%B1%89%E5%B8%82%E4%B8%9C%E6%B9%96%E6%96%B0%E6%8A%80%E6%9C%AF%E5%BC%80%E5%8F%91%E5%8C%BA%E5%85%B3%E5%B1%B1%E5%A4%A7%E9%81%93%E4%BF%9D%E5%88%A9%E5%9B%BD%E9%99%85%E4%B8%AD%E5%BF%83%207%20%E6%A5%BC%E6%B0%AA%E7%A9%BA%E9%97%B4/@12738102.301707588,3543590.205,14.78z?querytype=s&da_src=shareurl&wd=%E6%AD%A6%E6%B1%89%E5%B8%82%E4%B8%9C%E6%B9%96%E6%96%B0%E6%8A%80%E6%9C%AF%E5%BC%80%E5%8F%91%E5%8C%BA%E5%85%B3%E5%B1%B1%E5%A4%A7%E9%81%93%E4%BF%9D%E5%88%A9%E5%9B%BD%E9%99%85%E4%B8%AD%E5%BF%83%207%20%E6%A5%BC%E6%B0%AA%E7%A9%BA%E9%97%B4&c=289&src=0&pn=0&sug=0&l=17&b=(13525909.749999998,3650054.2825892856;13527486.370223215,3650769.0774107147)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2"
                    >
                      {t("common.footer.wuhan-address-name")}
                    </a>
                  </Tooltip>
                </div>
              </div>
              <div className="address">
                <div className="title">
                  {t("common.footer.footer-language")}
                </div>
                <div className="switch-lang">
                  <select name="lang" onChange={change} value={lang}>
                    {langs.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="item-add">15559944612</div>
                <div className="item-add">
                  {t("common.footer.footer-company-email")}
                </div>
                <div className="block flex-block">
                  <a
                    href="/privacy-policy.html"
                    className="item"
                    target="_blank"
                  >
                    {t("common.footer.footer-privacy-policy")}
                  </a>
                  <a
                    href="/service-agreement.html"
                    className="item"
                    target="_blank"
                  >
                    {t("common.footer.footer-service-agreement")}
                  </a>
                </div>
                {/* <div className="item gov-link">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://beian.miit.gov.cn/"
                  >
                    <span>{t("common.footer.footer-adress")}</span>
                  </a>
                </div>
                <div className="item gov-link">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035968"
                  >
                    <img
                      src="//files.authing.co/authing-website/icon-beian-gov.png"
                      alt="beian"
                    />
                    <span>{t("common.footer.footer-beian")}</span>
                  </a>
                </div> */}
                <div className="item footer-address">
                  {t("common.footer.footer-copyright")}
                </div>
                <div className="icons-link">
                  {communityLink.map((item, index) => {
                    if (item.type) {
                      return (
                        <div
                          className="wechat-code"
                          key={`${item.type}-${index}`}
                        >
                          <div key={index} className="icon-link">
                            <i className={item.icon}></i>
                          </div>
                          <div className="wechat-img">
                            <img
                              src="//files.authing.co/authing-website/wechat-code.jpg"
                              alt="authing"
                            />
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <a
                          key={`${item.type}-${index}`}
                          className="icon-link"
                          href={item.path}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className={item.icon}></i>
                        </a>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
            <div className="footer-bottom">
              <div className="friendly-link">
                {t("common.footer.footer-friendly-link")}:
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.showmebug.com"
                >
                  ShowMeBug
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.eolink.com/"
                >
                  Eolink
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.apifox.cn"
                >
                  Apifox
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={t("common.footer.footer-apiseven-link")}
                >
                  api7.ai
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.teamcode.com/"
                >
                  TeamCode
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.juzibot.com"
                >
                  {t("common.footer.footer-juzi")}
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.apipost.cn/"
                >
                  ApiPost
                </a>
              </div>
              <div className="beian-warp">
                <div className="gov-link">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035968"
                  >
                    <img
                      src="//files.authing.co/authing-website/icon-beian-gov.png"
                      alt="beian"
                    />
                    <span>{t("common.footer.footer-beian")}</span>
                  </a>
                </div>
                <div className="gov-link">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://beian.miit.gov.cn/"
                  >
                    <span>{t("common.footer.footer-adress")}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <MobileFooter menuList={menuList} communityLink={communityLink} />
      {renderFooter()}
    </>
  );
};
